import React from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';

import { getUserEmiValidity, removeCourseFromLibrary, showEmiModal } from '../../../../redux/slices/librarySlice';
import { startBuyNowProcess } from '../../../../redux/slices/checkoutSlice';

import InfoIcon from '../../../../assets/images/fixed-mock/info_black.svg';

import { courseExpireDate } from '../../../../utils/helper';

import styles from '../CourseCard.module.scss';

function BottomActionComponent({ course, isExpiring, isExpired }) {
  const dispatch = useDispatch();

  const handleExtendPackage = (event) => {
    event.stopPropagation();

    const { courseId, lanugageId: languageId } = course;
    dispatch(startBuyNowProcess({
      courseId,
      languageId,
      checkoutAction: 3,
    }));
  };

  const handleRenewPackage = (event) => {
    event.stopPropagation();

    const { courseId, lanugageId: languageId } = course;
    dispatch(startBuyNowProcess({
      courseId,
      languageId,
      checkoutAction: 2,
    }));
  };

  const repayEmi =
    course?.freeCourse === 0 &&
    course?.validityDaysLeft <= 15 &&
    course?.paymentType === 2 &&
    course?.totalPaidEmi !== course?.totalEmi;

  // Course Emi Repayment Handler
  const handleEmiRepayment = (event) => {
    event.stopPropagation();
    const { courseId, lanugageId } = course;

    dispatch(getUserEmiValidity({ courseId, lanugageId }));
    dispatch(showEmiModal({ show: true, courseId }));
  };

  const removeClick = (event) => {
    event.stopPropagation();
    const courseAction = course?.freeCourse === 1 ? 0 : 1;
    const courseID = course?.courseId;

    dispatch(removeCourseFromLibrary({ courseID, courseAction }));
  };

  if (course?.freeCourse) {
    return (
      <span className={classNames(styles.actionButton, styles.actionRemove)} onClick={removeClick}>
        Remove
      </span>
    );
  }

  if (course?.paymentMode?.toLowerCase() === 'collexo') {
    return (
      <span className={classNames(styles.actionButton, styles.courseItemInfoValidity)}>
        Valid Upto: <b>{courseExpireDate(course?.validityDate)}</b>
        {course.batchDateMessage && (
          <span className={styles.tooltip}>
            <InfoIcon />
            <div class={styles.top}>
              {course.batchDateMessage}
              <i />
            </div>
          </span>
        )}
      </span>
    );
  }

  // Disable for autopay courses
  if (course?.autoPayEnabled) {
    return (
      <span className={classNames(styles.actionButton, styles.courseItemInfoValidity)}>
        Valid Upto: <b>{courseExpireDate(course?.validityDate)}</b>
        {course.batchDateMessage && (
          <span className={styles.tooltip}>
            <InfoIcon />
            <div class={styles.top}>
              {course.batchDateMessage}
              <i />
            </div>
          </span>
        )}
      </span>
    );
  }

  if (repayEmi) {
    return (
      <span className={classNames(styles.actionButton, styles.actionPayEMI)} onClick={handleEmiRepayment}>
        Pay your EMI
      </span>
    );
  }

  // Extend action button
  if (isExpiring && course?.isCourseActive) {
    return (
      <span className={classNames(styles.actionButton, styles.actionRenewNow)} onClick={handleExtendPackage}>
        Renew now
      </span>
    );
  }

  // Renew action button
  if (isExpired && course?.isCourseActive) {
    return (
      <span className={classNames(styles.actionButton, styles.actionRenewNow)} onClick={handleRenewPackage}>
        Renew now
      </span>
    );
  }

  if (!repayEmi) {
    return (
      <span className={classNames(styles.actionButton, styles.courseItemInfoValidity)}>
        Valid Upto: <b>{courseExpireDate(course?.validityDate)}</b>
        {course.batchDateMessage && (
          <span className={styles.tooltip}>
            <InfoIcon />
            <div class={styles.top}>
              {course.batchDateMessage}
              <i />
            </div>
          </span>
        )}
      </span>
    );
  }
}

export default BottomActionComponent;
